import { Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { OpusJob, OpusJobsCriteria } from '../models';
import { OpusJobDetailsState, OpusJobsState as OpusJobState } from '../store';
import { takeWhile } from 'rxjs/operators';

import * as fromStore from '../store';

@Component({
  selector: 'opus-jobs-landing',
  templateUrl: './opus-jobs-landing.component.html'
})
export class OpusJobsLandingComponent implements OnInit, OnDestroy {
  @ViewChild('editor', { static: true }) editor;

  private _alive = true;
  criteria: OpusJobsCriteria;
  opusJobs$: Observable<OpusJob[]>;
  vm: OpusJobDetailsState;
  vm$: Observable<OpusJobDetailsState>;
  updatingOpusJobs = false;
  isEditing = false;

  constructor(private store: Store<OpusJobState>, private cdr: ChangeDetectorRef) {
    this.vm$ = this.store.pipe(select(fromStore.getOpusJobsDetailsState));
    this.opusJobs$ = this.store.pipe(select(fromStore.getOpusJobs));
  }

  ngOnInit(): void {
    this.vm$.pipe(takeWhile(() => this._alive)).subscribe(vm => {
      this.vm = vm;
      if (this.updatingOpusJobs) {
        this.updatingOpusJobs = false;
        this.isEditing = false;
      }
    });

    this.opusJobs$.pipe(takeWhile(() => this._alive));

    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this._alive = false;
    this.cdr.detach();
  }

  onCriteriaChange(criteria: OpusJobsCriteria) {
    this.criteria = criteria;
    this.store.dispatch(new fromStore.LoadOpusJobs(criteria));
  }

  onSaveChanges() {
    console.log('OpusJobsLandingComponent.onSaveChanges()...');

    const controls = this.editor.getChanges();
    let newArray = [];
    let changed = newArray.concat(
      controls
        .filter(g => g.controls.state !== null)
        .map(g => {
          const pic: OpusJob = {
            id: g.controls.id.value,
            enabled: g.controls.enabled.value,
            name: g.controls.name.value,
            state: g.controls.state.value,
            nextRunAt: g.controls.nextRunAt.value,
            startedAt: g.controls.startedAt.value,
            completedAt: g.controls.completedAt.value,
            message: g.controls.message.value,
            schedule: g.controls.schedule.value,
            retryCount: g.controls.retryCount.value,
            retryDelaySeconds: g.controls.retryDelaySeconds.value,
            lastModifiedBy: g.controls.lastModifiedBy.value,
            lastModifiedAt: g.controls.lastModifiedAt.value,
            updateApplyIntervalInSeconds: g.controls.updateApplyIntervalInSeconds.value
          };

          return pic;
        })
    );

    this.updatingOpusJobs = true;
    this.store.dispatch(new fromStore.UpdateOpusJobs({ changed }));
    /*this.store.dispatch(new fromStore.LoadShippingCharges(this.criteria));*/
  }

  onToggleEdit() {
    this.isEditing = !this.isEditing;
  }
}
